export default "__VITE_ASSET__5f8a84b3__"